import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-black backdrop-blur-sm z-50 shadow-sm">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <a href="/">
            <div className="flex items-center">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/huakar%2FLogo_Huakar_Systems-removebg-preview.png?alt=media&token=2213ce9b-1c0e-47d3-9955-1afb553679a6"
                alt="Huakar Logo"
                className="h-10 w-auto"
              />
              <span className="ml-2 text-xl font-bold text-blue-600">
                huakar
              </span>
            </div>
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600">
              Inicio
            </Link>
            <Link
              to="/huakar/services"
              className="text-gray-700 hover:text-blue-600"
            >
              Servicios
            </Link>

            <Link
              to="/huakar/contact"
              className="text-gray-700 hover:text-blue-600"
            >
              Contacto
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white shadow-lg md:hidden">
          <div className="px-4 pt-4 pb-6 space-y-2">
            <Link
              to="/"
              className="block px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-md"
              onClick={() => setIsMenuOpen(false)}
            >
              Inicio
            </Link>
            <Link
              to="/huakar/services"
              className="block px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-md"
              onClick={() => setIsMenuOpen(false)}
            >
              Servicios
            </Link>

            <Link
              to="/huakar/contact"
              className="block px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-md"
              onClick={() => setIsMenuOpen(false)}
            >
              Contacto
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
